angular.module("avant.customer_applications.directives").directive "broadcastScroll", [
  '$rootScope'
  ($rootScope) ->
    restrict: 'A'
    link: (scope, element, attrs) ->
      angular.element(element).scroll (event) ->
        $rootScope.$broadcast 'app:scroll', @scrollTop
]
